<app-widget-home-core
  [widget]="widget"
  [isStoreView]="isStoreView"
  [subheader]="(date | titlecase) + (local ? ' | ' + local : '')"
  (click)="onClickWidget()"
>

  <app-widget-principal-data
    label="% val."
    [data]="widgetData"
    [showData]="loadedData || isStoreView"
  ></app-widget-principal-data>

</app-widget-home-core>
